<template>
    <div id="account">
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-3">
                    <catalog-categories :account="true" class="mb-32"></catalog-categories>
                </div>
                <div class="col-xl-9 position-relative">
                    <div v-if="user">
                        <account-navigation></account-navigation>

                        <!-- MAIN -->
                        <account-main v-if="page === 'main'"></account-main>

                        <!-- NEW -->
                        <account-new v-if="page === 'new'"></account-new>

                        <!-- PERSONAL -->
                        <account-personal v-if="page === 'personal'"></account-personal>

                        <!-- REF -->
                        <account-ref v-if="page === 'ref'"></account-ref>

                        <!-- ORDERS -->
                        <account-orders v-if="page === 'order'"></account-orders>

                        <!-- CARD -->
                        <account-card v-if="page === 'card'"></account-card>

                        <!-- DISCOUNT -->
                        <span><account-discount v-if="page === 'discount'"></account-discount></span>
                    </div>


                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                </div>
            </div>
        </div>

        <show-card-modal></show-card-modal>
    </div>
</template>

<script>
    import store from '../../../services/data';
    export default {
        data() {
            return {
                store: store,
                breadcrumb: [
                    {
                        text: 'Главная',
                        href: '/'
                    },
                    {
                        text: 'Личный кабинет',
                        active: true
                    }
                ],

                loading: true

            }
        },

        computed: {
            page() {
                if(this.$route.name === 'account-orders') return 'order';
                if(this.$route.name === 'account-personal') return 'personal';
                if(this.$route.name === 'account-ref') return 'ref';
                if(this.$route.name === 'account-index') return 'main';
                if(this.$route.name === 'account-card') return 'card';
                if(this.$route.name === 'account-discount') return 'discount';
                if(this.$route.name === 'account-new') return 'new';
            },
            user() {
                return this.$store.getters.getUser;
            }
        },

        watch: {
            user() {
                if(this.user) this.showBanner();
            }
        },

        mounted() {
            if(this.user) this.showBanner();

        },

        methods: {
            showBanner() {
                this.loading = false;
                if ((!this.store.getItemlocalStorage('show_modal_card') || this.store.getItemlocalStorage('show_modal_card') != this.user.userData.id)
                    && ((this.user.card.type === 'Юридическое лицо' && !this.user.card.requisites) || (this.user.card.type === 'Физическое лицо' && !this.user.card.email))) {

                    setTimeout(this.showModal, 1200);
                    this.store.setItemlocalStorage('show_modal_card', this.user.userData.id);
                }
            },

            showModal() {
                this.$bvModal.show('showCardModal');
            },
        }
    }
</script>
